module.exports = __webpack_public_path__ + "static/media/barestho.bca43219.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/barestho.svg
// module id = 1483
// module chunks = 38